import { useEffect } from 'react';
import createMrktPageViewBrowser from 'spotify-event-definitions/events/createMrktPageViewBrowser';
import { PageId } from '../PageId';
import { logGabitoEvent } from '../logger';

type Props = {
  pageId: PageId | null;
  creatorUri: string | null;
  organizationUri: string | null;
};

export function usePageViewLogger({
  pageId,
  creatorUri,
  organizationUri,
}: Props) {
  useEffect(() => {
    if (!pageId) return () => {};

    const pageUri = window.location.href;

    logPageView({
      pageId,
      pageUri,
      creatorUri,
      organizationUri,
      navigationalRootId: null,
      type: 'enter',
    });

    return () => {
      logPageView({
        pageId,
        pageUri,
        creatorUri,
        organizationUri,
        navigationalRootId: null,
        type: 'exit',
      });
    };
  }, [pageId, creatorUri, organizationUri]);
}

type PageViewEvent = {
  pageId: PageId;
  pageUri: string;
  creatorUri: string | null;
  organizationUri: string | null;
  navigationalRootId: PageId | null;
  type: 'enter' | 'exit';
};

function logPageView({
  pageId,
  pageUri,
  creatorUri,
  organizationUri,
  navigationalRootId,
  type,
}: PageViewEvent) {
  logGabitoEvent(
    createMrktPageViewBrowser({
      page_id: pageId,
      page_uri: pageUri,
      creator_uri: creatorUri,
      organization_uri: organizationUri,
      navigational_root_id: navigationalRootId,
      type,
    }),
  );
}
